<template>
  <span :class="`c-checkbox c-checkbox-${type} c-checkbox-${size}`"
        :style="blockStyle">
  <span :class="`switch switch-${size}`" :style="blockStyle">
    <input :id="uid"
           :disabled="disabled"
           type="checkbox"
           v-model="checked"/>
    <label :for="uid" v-if="!empty" :class="sideClass">
      <div><slot name="default"></slot></div>
    </label>
    <label :for="uid" v-else class="label-empty">
    </label>
  </span>
</span>
</template>
<script>
import assert from '@/sui/tools/assert'

export default {
  name: 'custom-checkbox',
  props: {
    value: {
      type: Boolean,
      required: true
    },

    type: {
      type: String
    },

    size: {
      type: String,
      default: 'md'
    },

    side: {
      type: String,
      default: 'right'
    },

    block: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    empty: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      checked: this.value
    }
  },

  watch: {
    value: function (val) {
      if (val !== this.checked) {
        this.checked = val
      }
    },

    checked: function () {
      this.$emit('input', this.checked)
    }
  },

  computed: {
    uid () {
      return 'c-checkbox-' + this._uid
    },

    blockStyle () {
      return this.block ? { width: '100%' } : {}
    },

    sideClass: function () {
      const s = this.side
      assert(s === 'right' || s === 'left')
      return `check-box-${s}`
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';
@import '~modules';
@import '~observa4';

.c-checkbox {
  max-width: 550px;
  display: inline-block;
  vertical-align: middle;
}

.switch {
  background-color: #eee;
  display: block;
  position: relative;
  border-radius: 4px;
  border: 3px solid;
  transition: all 200ms ease-in;

  label {
    padding: 1.2rem 1.2rem;
    min-width: 100%;
    display: block;
    text-align: left;
    color: #3C454C;
    cursor: pointer;
    position: relative;
    z-index: 2;
    transition: color 200ms ease-in;
    overflow: hidden;
    margin: 0rem;
    margin-right: 4rem;
    user-select: none;

    &:before {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      content: '';
      background-color:teal;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) scale3d(1, 1, 1);
      -ms-transform: translate(-50%, -50%) scale3d(1, 1, 1);
      transition: all 300ms cubic-bezier(0.4, 0.0, 0.2, 1);
      opacity: 0;
      z-index: -1;
    }

    &:after {
      width: 32px;
      height: 32px;
      content: '';
      border: 2px solid #C1C7DC;
      background-color: #fff;
      background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
      background-repeat: no-repeat;
      background-position: 2px 3px;
      border-radius: 4px;
      z-index: 2;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      transition: all 200ms ease-in;
    }
  }

  .check-box-right {
    &:after {
      right: 5%;
    }

    & > div {
      max-width: 90%;
    }
  }

  .check-box-left {
    &:after {
      left: 3%;
    }
  }

  label.check-box-left > div {
    margin-left: 3%;
    padding-left: 26px;
  }

  input:disabled ~ label {
    cursor: not-allowed;
  }

  input:checked ~ label {
    color: #fff;

    &:before {
      transform: translate(-50%, -50%) scale3d(60, 60, 1);
      -ms-transform: translate(-50%, -50%) scale(60, 60);
      opacity: 1;
    }

    &:after {
      background-color: #54E0C7;
      border-color: #54E0C7;
    }
  }

  label.label-empty {
    padding: 0rem;
    margin: 0px;
    height: 40px;
    width: 40px;

    &:after {
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  input {
    order: 1;
    z-index: 2;
    position: absolute;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
    visibility: hidden;
  }
}

.switch-sm {
  border: 1px solid;
  border-radius: 3px;
  label {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    font-weight: normal;

    &:after {
      width: 20px;
      height: 20px;
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
      background-position: 1px 2px;
    }
  }

  label.label-empty {
    height: 28px;
    width: 28px;
  }

  label.check-box-left > div {
    padding-left: 20px;
  }
}

.switch-xs {
  border: 2px solid;
  label {
    padding: 0.4rem 0.8rem;
    font-size: 80%;
    font-weight: normal;

    &:after {
      width: 18px;
      height: 18px;
      background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
      background-position: 0px 1px;
    }
  }

  label.label-empty {
    height: 20px;
    width: 20px;
  }

  label.check-box-left > div {
    padding-left: 18px;
  }
}

</style>
